import { render, staticRenderFns } from "./AddCompanyLogo.vue?vue&type=template&id=04ff0ab0"
import script from "./AddCompanyLogo.vue?vue&type=script&lang=js"
export * from "./AddCompanyLogo.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports